import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { PatientexaminationData, PatientexaminationMst } from '../../../interfaces/masters/patientexamination';
import { PatientexamintionApi } from '../api/patientexamintion.api';

@Injectable()
export class PatientexaminationService extends PatientexaminationData {

  constructor(private api: PatientexamintionApi) {
    super();    
  }
  list(url: string): Observable<PatientexaminationMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<PatientexaminationMst>{
      return this.api.getById(url); 
  }
  create(url: string, data:PatientexaminationMst): Observable<PatientexaminationMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:PatientexaminationMst): Observable<PatientexaminationMst> {
    return this.api.update(url,data);
  }  
  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
